export const API_BASE_URL = 'https://api.stage.wandawazi.com/flow/api';

export const BILLING_ENABLED = true;

export const APP_ENV = 'stage';
export const APP_VERSION = '2.4.2';
export const RELEASE_NOTES = {
  id: '2.4.2',
  title: 'What’s new',
  body: 'You can now create a Flow account through Core onboarding. Staff access follows approved memberships, and new care recipients are created in Core for the tenant you are in. Existing recipients still appear as before.',
  show: true,
};

export const AUTH_URL = 'https://api.stage.wandawazi.com/core/api/v1/auth/token';

export const REFRESH_URL = 'https://api.stage.wandawazi.com/core/api/v1/auth/refresh';

export const SELECT_TENANT_URL = 'https://api.stage.wandawazi.com/core/api/v1/auth/select-tenant';

export const APPLICATION_ID = '63ea4192-f656-4bf4-9087-7c306202f6c6';

export const CORE_ONBOARDING_ORIGIN = 'https://stage.core.wandawazi.com';

export const HANDOFF_EXCHANGE_URL = 'https://api.stage.wandawazi.com/core/api/v1/onboarding/handoff/exchange';

export const ONBOARDING_RETURN_URL = 'https://stage.flow.wandawazi.com';

// export const API_BASE_URL = 'http://localhost:3002/api';

// Customer-Tenant-Site API Endpoints
export const CUSTOMER_API = {
    // Customer endpoints
    LIST: `${API_BASE_URL}/care-recipients`,
    GET: (id) => `${API_BASE_URL}/care-recipients/${id}`,
    CREATE: `${API_BASE_URL}/care-recipients`,
    UPDATE: (id) => `${API_BASE_URL}/care-recipients/${id}`,
    
    // Tenant management endpoints
    GET_TENANTS: (customerId) => `${API_BASE_URL}/customers/${customerId}/tenants`,
    ASSIGN_TENANTS: (customerId) => `${API_BASE_URL}/customers/${customerId}/tenants`,
    SET_PRIMARY_TENANT: (customerId) => `${API_BASE_URL}/customers/${customerId}/primary-tenant`,
    REMOVE_TENANT: (customerId, customerTenantId) => `${API_BASE_URL}/customers/${customerId}/tenants/${customerTenantId}`,
    
    // Site management endpoints
    GET_SITES: (customerId, tenantId) => `${API_BASE_URL}/customers/${customerId}/sites${tenantId ? `?tenant_id=${tenantId}` : ''}`,
    ASSIGN_SITES: (customerId) => `${API_BASE_URL}/customers/${customerId}/sites`,
    REMOVE_SITE: (customerId, tenantSiteId) => `${API_BASE_URL}/customers/${customerId}/sites/${tenantSiteId}`,
    
    // Site customers endpoint
    GET_SITE_CUSTOMERS: (siteId, tenantId) => `${API_BASE_URL}/sites/${siteId}/customers${tenantId ? `?tenant_id=${tenantId}` : ''}`,
};

 